import React, { useState } from "react";

import PengaturanModal from "../../../Layout/Components/PengaturanModal";
import { CreateButton } from "../../../CommonElements";
import DokumenForm from "./DokumenForm";

function ModalUploadDokumen({ resetState }) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const button = <CreateButton toggle={toggle}>Upload Dokumen</CreateButton>;

  return (
    <>
      <PengaturanModal
        button={button}
        title={"Upload Dokumen"}
        isOpen={isOpen}
        toggle={toggle}
      >
        <DokumenForm resetState={resetState} toggle={toggle} />
      </PengaturanModal>
    </>
  );
}

export default ModalUploadDokumen;
